import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";

import {rastreamentosModuleName, time} from "../shared/data.service";
import { FrotaApiService } from "../../bens/frotas/shared/frota-api.service";
import {RastreamentoService} from "../shared/rastreamento.service";
import {RastreamentoApiService} from "../shared/rastreamento-api.service";
import {UtilService} from "../../shared/services/util.service";
import {ExportCsvService} from "../../shared/services/export-csv.service";

@Component({
    template: require('./rastreamento-historico.component.html'),
    styles: [require('./rastreamento-historico.component.css')]
})
export class RastreamentoHistoricoComponent implements OnInit, AfterViewInit {
    list: any[] = [];
    loading: boolean = true;
    loadingBem: boolean = true;
    module: any = rastreamentosModuleName;
    detail: any = {};

    timeListStart: any[] = [];
    timeListEnd: any[] = [];
    timeStart: any;
    timeEnd: any;
    dataInicial: any;
    dataFinal: any;

    private page = 0;
    private limit = 100;
    private bemId: number;

    constructor(
        private _frotaApiService: FrotaApiService,
        private _rastreamentoService: RastreamentoService,
        private _rastreamentoApiService: RastreamentoApiService,
        private _utilService: UtilService,
        private _exportService: ExportCsvService,
        private _route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.timeListStart = this._utilService.cloneObject(time);
        this.timeListEnd = this._utilService.cloneObject(time);

        this.bemId = +this._route.snapshot.params['id'];
        this.getBem();
    }

    ngAfterViewInit() {
        this._utilService.disabledFutureDates('data_final');
        this._utilService.disabledFutureDates('data_inicial');

        this.dataInicial = this._utilService.convertDateToString(new Date());
        this.dataFinal = this._utilService.convertDateToString(new Date());

        this.timeStart = this.timeListStart[0];
        this.timeEnd = this.timeListEnd[this.timeListStart.length - 1];

        setTimeout(function() {
            this.clickSearch();
        }.bind(this));
    }

    clickGoToList() {
        this._rastreamentoService.goToVehicles();
    }

    changeStartTime() {

    }

    changeEndTime() {

    }

    clickNext() {
        this.page += 1;
        this.clickSearch();
    }

    clickPrevious() {
        this.page -= 1;
        this.clickSearch();
    }

    clickSearch() {
        const queryWhere = this.getDateTime();
        this.getLog(queryWhere);
    }

    clickExport() {
        const queryWhere = this.getDateTime();
        this.getLogExport(queryWhere);
    }

    private getBem() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.detail = Response;
                this.loadingBem = false;
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum veículo encontrado com este id.');
                this.clickGoToList();
            }
        }.bind(this));

        this._frotaApiService.onGetById(this.bemId, onDone);
    }

    private getDateTime() {
        if (!this.timeStart || !this.timeEnd || !this.dataFinal || !this.dataInicial) {
            return false;
        }

        let dateStart: any = document.getElementById('data_inicial');
        if (dateStart.value) {
            dateStart = dateStart.value;
        }

        let dateEnd: any = document.getElementById('data_final');
        if (dateEnd.value) {
            dateEnd = dateEnd.value;
        }

        let timeStart: any = this.timeStart;
        if (timeStart) {
            timeStart = ((timeStart.Key < 10) ? '0'+timeStart.Key.toString() : timeStart.Key.toString()).concat(":00");
        }

        let timeEnd: any = this.timeEnd;
        if (timeEnd) {
            timeEnd = ((timeEnd.Key < 10) ? '0'+timeEnd.Key.toString() : timeEnd.Key.toString()).concat(":00");
        }

        let start: any = this._utilService.convertStringToDateTime(dateStart, timeStart);
        let end: any = this._utilService.convertStringToDateTime(dateEnd, timeEnd);

        let queryWhere: any = [];
        if (start instanceof Date) {
            queryWhere.push({data:{'gte':start}});
        }

        if (end instanceof Date) {
            queryWhere.push({data:{'lte':end}});
        }

        return queryWhere;
    }

    private getLog(queryWhere: any) {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                Response.forEach((item: any) => {
                   if (item.kmPorHora) {
                       item.kmPorHora = item.kmPorHora.toFixed(2);
                   }
                });
                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        let query: any = {
            order: "data DESC",
            include: ["gpsModelo"],
            limit: this.limit,
            skip: this.page,
            where: {
                bemId: this.bemId,
                ativo: true
            }
        };
        query.where.and = queryWhere;

        this.loading = true;
        this._rastreamentoApiService.onGetAll(query, onDone);
    }

    private getLogExport(queryWhere: any) {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                Response.forEach((item: any) => {
                    if (item.kmPorHora) {
                        item.kmPorHora = item.kmPorHora.toFixed(2);
                    }
                });
                this._exportService.JsonToCsvConvertor(Response, 'GeosiapFrotas_log_rastreamento', true);
            }
            this.loading = false;
        }.bind(this));

        let query: any = {
            order: "data DESC",
            where: {
                bemId: this.bemId,
                ativo: true
            }
        };
        query.where.and = queryWhere;

        this.loading = true;
        this._rastreamentoApiService.onGetAll(query, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/rastreamento-historico/rastreamento-historico.component.ts
 **/